import React, { useState } from 'react'

import { OrderItemPriceSummaryV3 } from '~/components/order-item-price-summary'
import { PassRestrictionWarningV2 } from '~/components/pass-restriction-warning'
import ProductHeading from '~/components/product-heading'
import { i18n } from '~/i18n'

import {
  RemoveButton,
  OrderItem as _OrderItem,
  ProfileV2,
  Header,
  StyledCard,
} from './order-item-v3.styles'

import type { OrderItemProps } from './order-item.types'

export const OrderItemV3 = ({
  originalPrice,
  pricingDetails,
  totalPrice,
  productName,
  profileName,
  displayName,
  displayAgeRange,
  forceShowTotalLineItem,
  isUpgrade,
  restrictionWarning,
  onAddonToggle,
  internalId,
  onRemove,
  appliedAddons,
  applicableAddons,
}: OrderItemProps) => {
  const [hidden, setHidden] = useState(false)

  const toggleAddon = (state: boolean, addonType: string) => {
    if (onAddonToggle) {
      onAddonToggle(state, internalId, addonType)
    }
  }

  // Consider the absence of `onAddonToggle` as a flag for
  // the order item being read only.
  const isReadOnly = !onAddonToggle

  // Instantly hides cart item on removal, instead of waiting for API response.
  const onRemoval = () => {
    if (onRemove) onRemove()
    setHidden(true)
  }

  if (hidden) return null

  return (
    <StyledCard withBorder>
      <_OrderItem data-testid="order-item">
        <Header>
          <ProductHeading title={productName} titleVariant="large" />
          {onRemove && (
            <RemoveButton onRemove={onRemoval}>
              {i18n.t('components.order_itemv3.remove')}
            </RemoveButton>
          )}
        </Header>
        {profileName && <ProfileV2 profileName={profileName} />}
        <OrderItemPriceSummaryV3
          displayName={displayName || ''}
          displayAgeRange={displayAgeRange || ''}
          originalPrice={originalPrice}
          pricingDetails={pricingDetails}
          isUpgrade={isUpgrade}
          toggleAddon={toggleAddon}
          isReadOnly={isReadOnly}
          totalPrice={totalPrice}
          forceShowTotalLineItem={forceShowTotalLineItem}
          appliedAddons={appliedAddons}
          applicableAddons={applicableAddons}
        />
        {restrictionWarning && (
          <PassRestrictionWarningV2 message={restrictionWarning} />
        )}
      </_OrderItem>
    </StyledCard>
  )
}

export default OrderItemV3
